import { Container } from "reactstrap";
import LeftSideRibbons from "./LeftSideRibbons";
import RightSideRibbon from "./RightSideRibbon";
import { BonusUi, RibbonsTitle } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const RibbonsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={RibbonsTitle} parent={BonusUi} />
      <Container fluid>
        <LeftSideRibbons />
        <RightSideRibbon />
      </Container>
    </>
  );
};
export default RibbonsContainer;
